import React from 'react';
import WName, {WArticle} from '../../WName';
import PL from '../../problems/ProblemLink';
import QL from '../../faq/QuestionLink';
import AL from '../../angles/AngleLink';
import NW from '../../neologisms/NewWord';
import OML from '../../ormaybe/OrMaybeLink';
import LRL from '../LongReadLink';
import {E1, E2, TLDR, Qual, Rando, Switcheroo} from '../../common';

// ‘’ … –

export const blamegame = {
  name: "blame game",
  alternatives: "fault,blame",
  prelude: <span>
    But whose <i>fault</i> is it, <i>really</i>???
  </span>,
  header: <span>
    Enough of the ‘Blame Game’.
  </span>,
  outside: <span>
    Making it the ‘fault’ of one Self<sup>™</sup> is a <NW>ziggurat</NW>, <QL name="tldr">frankly</QL>. <PL>Individuality</PL> is just an <NW>illusion</NW>, so does it <i>really</i> <OML>matter</OML>?
  </span>,
  preview: <div className="long-read-preview">
    <p><TLDR />: if something goes <i>wrong</i> (i.e., <OML name="harmony">sub-optimally</OML>), <WArticle /> <WName ist /> doesn’t care if it’s the ‘fault’ of which <i><AL name="handicap">body</AL></i>. Ze would care: is it the ‘fault’ of which <i><LRL name="notions">idea</LRL></i>?</p> 
   <p>Nevertheless, 2020’s <LRL name="gaiacentrism">Earth</LRL> is <PL>reactively</PL> insistent on <i>blaming</i>: the <PL name="comfort">purrfect</PL> <NW>ziggurat</NW>. This is the <i>essence</i> of the ‘Blame Game<sup>(®)</sup>’:</p>
    <ul>
      <li>It is <i>not</i> MY<sup>™</sup> fault. <i><PL name="loc">Definitively</PL></i> not MINE<sup>™</sup>.</li>
      <li>Therefore (∴ – the ‘<QL name="silly names">bowling ball symbol</QL>’) it is a <NW>SEP</NW>.</li>
      <li>Therefore it is not <AL name="self">MY<sup>™</sup></AL> <i>responsibility</i>, and if I<sup>™</sup> am a ‘good <QL name="TM">Person™</QL>’ (in <QL>isolation</QL>), I <i><PL name="comfort">don’t have to worry</PL> about it</i>.</li>
    </ul>
  </div>,
  readMore: "Click for the older version",
  text: <div className="long-read-text">
    <h3>Older version</h3>
    <p>The <WName ic /> <AL>framework</AL> doesn’t allow for <PL>individuality</PL>, <AL name="bulletpoints">remember</AL>? Looking at <PL name="ick">everything</PL> as a <AL>system</AL>, the actual thing of import is to dig ‘<LRL>deep</LRL>’ to uncover which <i><OML>ideas</OML></i> caused the <PL name="ick.">system</PL> to go awry (on the ‘<LRL name="notions">battlefield of <i>notions</i></LRL>’).</p>
    <p>But be <PL name="endsjustifymeans">really careful</PL> with that approach; this <AL name="fields.philosophy">quantum-mechanical philosophy</AL> is so <PL name="hard">difficult</PL> to truly <LRL>understand</LRL> that it’s incredibly easy for some <NW word="ig">individually greedy</NW> <QL>human</QL> to <PL name="dangerous">corrupt</PL> it – and then, as much as the ‘blame game’ is (on the whole) <i>not</i> helpgul to our <QL>unity</QL> <QL>consciousness</QL>, this <i>would</i> be that one <PL>individual</PL>’s ‘fault’. </p>
  </div>,
};
